import React, { useEffect } from 'react';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { JoykitIcon } from '@components/JoykitIcon';
import { CTALink } from '@components/CTALink';
import { Text } from '@components/typography';
import { StyledModal, ModalWrapper, ModalBody, VideoContainer, StyledCloseButton } from './VideoModal.styles';
import { VimeoVideo } from '@components/VimeoVideo';

export interface VideoModalProps {
  readonly isModalOpen: boolean;
  readonly videoUrl: string;
  readonly poster: string;
  readonly title?: string;
  readonly caption?: string;
  readonly cta?: {
    text: string;
    link: string;
    onClick?: () => void;
  };
  readonly handleClose: () => void;
}

export const VideoModal: React.FC<VideoModalProps> = props => {
  const { isModalOpen, videoUrl, poster, title, caption, cta, handleClose } = props;
  useEffect(() => {
    if (isModalOpen) {
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.documentElement.style.overflow = 'unset';
    }
  }, [isModalOpen]);
  return (
    <StyledModal
      isOpen={isModalOpen}
      onRequestClose={handleClose}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      ariaHideApp={false}
      style={{
        overlay: {
          background: 'rgba(0, 0, 0, 1)',
          zIndex: 101,
          overflow: 'auto',
          border: 'none',
          width: '100vw',
          height: '100vh',
          top: 0,
          left: 0,
        },
      }}
    >
      <ModalWrapper alignItems="center" justifyContent="center" flexDirection="column">
        <Flex justifyContent="flex-end" style={{ width: '100%' }}>
          <StyledCloseButton id="video-modal-close" variant="altPurpleSecondary" onClick={handleClose} skipRedirectWithTelemetry={true}>
            <JoykitIcon name="notAttending" color="mono6" size={16} />
          </StyledCloseButton>
        </Flex>
        <Flex>
          <ModalBody alignItems="center" justifyContent="center" flexDirection="column">
            <VideoContainer>
              <VimeoVideo embedUrl={videoUrl} title="RZ Announcement" autoPlay />
            </VideoContainer>
            <Flex justifyContent="space-between" style={{ width: '100%' }}>
              <Flex flexDirection="column">
                {caption && (
                  <Flex>
                    <Text color="mono6" variant="caption" tagName="h4">
                      {caption}
                    </Text>
                  </Flex>
                )}
                {title && (
                  <Flex>
                    <Text color="mono6" variant="featureCopy17" tagName="h3" style={{ fontWeight: 600 }}>
                      {title}
                    </Text>
                  </Flex>
                )}
              </Flex>
              {cta && (
                <Box>
                  <CTALink
                    id="videoModalCta"
                    href={cta.link}
                    typography="featureHed17"
                    variant="alternative"
                    hasChevron
                    onClick={cta.onClick}
                  >
                    {cta.text}
                  </CTALink>
                </Box>
              )}
            </Flex>
          </ModalBody>
        </Flex>
      </ModalWrapper>
    </StyledModal>
  );
};
